import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, IdCardIcon } from 'lucide-react';
import { citizen, familyMembers, walletCards } from '../../data/carte';
const credentials = ['Résident', 'Piscine', 'Activité inscrite', 'Accès installation', 'Réservation'];

/** L'aperçu reprend la titulaire, la ville et le numéro de la vraie carte, pour ne jamais diverger. */
const holder = familyMembers[0];
const lastDigits = walletCards[0].number.slice(-4);
export function CardAccess() {
  return <section aria-labelledby="carte-acces-titre" className="mt-14 grid gap-6 rounded-3xl border border-slate-200 bg-white p-6 sm:p-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,320px)] lg:items-center" data-id="element-1976" data-mp="3t7h6vmal906s">
      <div data-id="element-1977" data-mp="3jaktp39qvpvw">
        <h2 id="carte-acces-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1978" data-mp="3jb42nuhf33xs">
          Ma carte numérique
        </h2>
        <p className="mt-2 max-w-xl text-[15px] leading-relaxed text-slate-600" data-id="element-1979" data-mp="1hi6eibyl4zj6">
          Votre carte vous permet d’accéder à vos activités et installations participantes. Aucune autre carte de
          loisirs n’est nécessaire.
        </p>
        <ul className="mt-4 flex flex-wrap gap-2" data-id="element-1980" data-mp="1r5hpqwczma8y">
          {credentials.map(credential => <li key={credential} className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-ville-navy" data-id="element-1981" data-mp="1d68kgrqbl0jr">
              {credential}
            </li>)}
        </ul>
        <Link to="/ma-carte" className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-ville-indigo hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1982" data-mp="25ue3na1q6hhh">
          Voir ma carte
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1983" data-mp="21247hca0ol6r" />
        </Link>
      </div>

      <div className="rounded-2xl bg-ville-navy p-5 text-white" data-id="element-1984" data-mp="2orynu3tjorvr">
        <div className="flex items-center justify-between" data-id="element-1985" data-mp="2oqng5swzazzd">
          <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em]" data-id="element-1986" data-mp="2tjynrw9m7ksc">
            <IdCardIcon className="h-4 w-4 text-ville-lime" aria-hidden="true" data-id="element-1987" data-mp="33dugz5sr2hkj" />
            Carte numérique
          </span>
          <span className="text-xs font-semibold text-white/60" data-id="element-1988" data-mp="2ydzrn6omi01l">{citizen.city}</span>
        </div>
        <p className="mt-6 text-lg font-extrabold" data-id="element-1989" data-mp="2tj2ky6etg2rv">
          {holder.firstName} {holder.lastName}
        </p>
        <p className="font-mono text-sm tracking-[0.2em] text-white/70" data-id="element-1990" data-mp="2phqr1oowsvdv">•••• •••• {lastDigits}</p>
      </div>
    </section>;
}